import React from 'react';
import PropTypes from 'prop-types';
import { propTypes as CakesPropTypes } from '@config/Validators/cake.validator';
import t from '@unicat/i18n/Translate';
import map from 'lodash/map';
import { useStyles } from '@unicat/CakePageContent/styles';
//import CakeImage from '@unicat/UI/CakeImage/CakeImage';

const MostPopularCakes = ({ popular = [], limit = 6 }) => {
  const classes = useStyles();

  return (
    <>
      <div className={classes.popular}>
        <p className={classes.titlePopular}>Most Popular Cakes</p>
        <div className={classes.grid}>
          {map(popular.slice(0, limit), (x, index) => (
            <a href={x.cakeInfo.link} className={classes.popularLink} key={x.id + index} title={t(x.id)}>
              <img src={x.imgLink[0]} alt={t(x.id)} />
            </a>
          ))}
        </div>
      </div>
    </>
  );
};

MostPopularCakes.defaultProps = {};

MostPopularCakes.propTypes = {
  popular: PropTypes.arrayOf(PropTypes.shape({ ...CakesPropTypes })).isRequired,
  limit: PropTypes.number,
};

export default MostPopularCakes;
